import React from 'react';
import { Box, Breadcrumbs, ButtonBase, Paper, Slider, Typography } from '@mui/material';
import { BASE_COLORS } from '../../../constants';
import { useDroughtWarning } from './DroughtWarningContext';
import { DROUGHT_FILTER_ITEMS } from './droughtWarning.constants';
import DroughtWarningMeparSearch from './DroughtWarningMeparSearch';

const HEADER_SX = {
    minHeight: 36,
    backgroundColor: BASE_COLORS.PRIMARY_MAIN,
    border: `1px solid ${BASE_COLORS.PRIMARY_MAIN}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    color: BASE_COLORS.WHITE,
};

const DroughtWarningFilterBar = () => {
    const {
        selectedMeparCode,
        selectedFilter,
        selectedOpacity,
        setSelectedFilter,
        setSelectedOpacity,
        setSelectedMeparCode,
    } = useDroughtWarning();

    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: {
                    xs: '1fr',
                    lg: 'minmax(0, 1fr) 0',
                },

                width: '100%',
            }}
        >
            <Paper
                elevation={0}
                square
                sx={{
                    ...HEADER_SX,
                    px: { xs: 1, sm: 1.5 },
                    py: 1,
                    borderRadius: 1,
                    gap: { xs: 1, md: 2 },
                    flexDirection: { xs: 'column', lg: 'row' },
                    alignItems: { xs: 'stretch', lg: 'center' },
                }}
            >
                <Breadcrumbs
                    aria-label="aszaly breadcrumb"
                    separator="/"
                    sx={{
                        width: '100%',
                        '& .MuiBreadcrumbs-ol': {
                            flexWrap: 'wrap',
                            justifyContent: 'start',
                            rowGap: 0.25,
                        },
                        '& .MuiBreadcrumbs-separator': {
                            color: BASE_COLORS.WHITE,
                            mx: { xs: 0.25, sm: 0.5, md: 0.75 },
                            fontSize: { xs: 16, md: 18 },
                            lineHeight: 1.1,
                        },
                    }}
                >
                    {DROUGHT_FILTER_ITEMS.map((item) => {
                        const isActive = item.value === selectedFilter;

                        return (
                            <ButtonBase
                                key={item.value}
                                onClick={() => setSelectedFilter(item.value)}
                                aria-current={isActive ? 'page' : undefined}
                                sx={{
                                    color: isActive ? BASE_COLORS.PRIMARY_MAIN : BASE_COLORS.WHITE,
                                    bgcolor: isActive ? BASE_COLORS.WHITE : 'transparent',
                                    fontSize: { xs: 15, sm: 16, md: 18 },
                                    lineHeight: 1.1,
                                    px: { xs: 0.75, sm: 1 },
                                    py: { xs: 0.75, sm: 1 },
                                    borderRadius: 1,
                                    fontWeight: isActive ? 700 : 400,
                                    textUnderlineOffset: '2px',
                                    transition: 'all 0.1s ease-in-out',
                                    '&:hover': {
                                        bgcolor: BASE_COLORS.WHITE,
                                        color: BASE_COLORS.PRIMARY_MAIN,
                                    },
                                }}
                            >
                                {item.label}
                            </ButtonBase>
                        );
                    })}
                </Breadcrumbs>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        alignItems: 'center',
                        gap: { xs: 1, sm: 1.5 },
                        width: { xs: '100%', lg: 'auto' },
                        minWidth: { lg: 540 },
                        justifyContent: { xs: 'flex-start', lg: 'flex-end' },
                    }}
                >
                    <Box
                        sx={{
                            width: { xs: '100%', sm: 160 },
                            mr: { xs: 0, sm: 2 },
                        }}
                    >
                        <Typography
                            sx={{
                                color: BASE_COLORS.WHITE,
                                fontSize: 12,
                                lineHeight: 1,
                                mb: 0.5,
                            }}
                        >
                            Réteg átlátszatlanság
                        </Typography>
                        <Slider
                            min={1}
                            max={10}
                            step={1}
                            value={Math.round(selectedOpacity * 10)}
                            onChange={(_, value) => {
                                setSelectedOpacity(value);
                            }}
                            valueLabelDisplay="auto"
                            valueLabelFormat={(value) => `${(value / 10).toFixed(1)}`}
                            sx={{
                                color: BASE_COLORS.WHITE,
                                py: 0,
                                '& .MuiSlider-rail': {
                                    opacity: 0.35,
                                },
                                '& .MuiSlider-valueLabel': {
                                    backgroundColor: BASE_COLORS.WHITE,
                                    color: BASE_COLORS.PRIMARY_MAIN,
                                    fontWeight: 700,
                                },
                            }}
                        />
                    </Box>

                    <DroughtWarningMeparSearch
                        selectedMeparCode={selectedMeparCode}
                        onSelectMepar={(item) => {
                            if (!item?.meparCode) {
                                setSelectedMeparCode(null);
                                return;
                            }

                            setSelectedMeparCode(item.meparCode);
                        }}
                    />
                </Box>
            </Paper>
        </Box>
    );
};

export default DroughtWarningFilterBar;
